import * as THREE from 'three';
import bgVert from "../glsl/bg.vert";
import bgFrag from "../glsl/bg.frag";
import { Params } from '../data/Params';

export class BgObj extends THREE.Object3D{

    constructor(){
        super();


        let bgMat = new THREE.ShaderMaterial({
            uniforms: {
                time: {value: 1.0},
                dLight:{value:Params.dLight.position},
                resolution: {value: new THREE.Vector2()},
                projMat: {value: new THREE.Matrix4()},
                colorId:{value: Params.colorId}
            },
            vertexShader: bgVert,
            fragmentShader: bgFrag
          });
          bgMat.side = THREE.DoubleSide;
          
          let bg = new THREE.Mesh(
            new THREE.SphereGeometry(1000, 20, 20),
            bgMat
            ////new THREE.MeshBasicMaterial({color:0x00ff00})
          );
          this.add(bg);

    }



}